<template>
  <div class="detail">
      <div class="box" v-if="detailItem">
            <div class="back" @click="goback">
                <i class="el-icon-arrow-left"></i>返回
            </div>
            <div class="subtitle">{{detailItem.subtitle}}</div>
            <div class="title">{{detailItem.title}}</div>
            <div class="time">{{detailItem.updated_at}}</div>
            <div class="context" v-html="detailItem.content"></div>
      </div>
  </div>
</template>
<script>
import { getCaseDetail } from "@/config/axios/new_api";
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'manage',
  components: {
    banner,
  },
  data() {
    return {
     detailItem:null
    };
  },
  created() {
    let data ={
        case_id:this.$route.query.id,
    }
    if(this.$route.query.preview){
        data.preview = 1
    }
    getCaseDetail(data).then((res)=>{
      if(res.data.status == 1){
        this.detailItem = res.data.data;
      }
    })
  },
  
  methods: {
    goback(id){
            this.$router.go(-1)
    }
  },
}
</script>
<style lang="scss" scoped>
.detail{
    background: #F7F7F9;
    display: flex;
    justify-content: center;
    padding-top: 60px;
    min-width: 1200px;
    .box{
        width: 750px;
        padding: 0 35px;
        background: #FFF;
    }
    .back{
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 24px 0;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9E9DA7;
        line-height: 20px;
        i{
            margin-right: 2px;
            font-size: 20px;
        }
    }
    .title{
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3B3946;
        line-height: 37px;
        margin-top: 24px;
    }
    .time{
        margin-top: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9E9DA7;
        line-height: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #E3E1EA;
    }
    .context{
        margin-top: 16px;
        padding-bottom: 49px;
    }
}
</style>